import { useTranslation } from 'react-i18next';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { IdeaCreationFormWrapper } from 'src/Components/Forms/Idea/IdeaCreationFormWrapper';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

const CreateIdeaDrawer = () => {
  const { t } = useTranslation();
  const assetId = useCurrentAssetId();

  return (
    <AnimatedRoutedDrawer
      title={t('ideas.create.title', 'Nouvelle idée')}
      to={`/asset/${assetId}/project-and-works`}
    >
      {({ onClose }) => <IdeaCreationFormWrapper onClose={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default CreateIdeaDrawer;
